module.exports = __webpack_public_path__ + "static/media/logo.539ef9c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/logos/logo.svg
// module id = 1761
// module chunks = 0